import React, 
       { useEffect, 
         useState, 
         useContext}          from 'react';
import api                    from './AxiosConfig';
import { useNavigate }        from 'react-router-dom';
import { BsBarChartLineFill, 
         BsFillPencilFill,
         BsFillGearFill,
         BsFillStopwatchFill} from "react-icons/bs";
import ProgressBarItem        from './ProgressBarItem';
import { AuthContext }        from './AuthContext';
import RAGStatus              from './RAGStatus';

function SubGoalRow( props ) {
  const [goal, setGoal] = useState([]);
  const navigate        = useNavigate();
  const { isLoggedIn }  = useContext(AuthContext);
  
  useEffect(() => {
      async function getGoal() {
          if (isLoggedIn && isLoggedIn === true && props && props.goalId) {
              try {
                  const response = await api.get(`/site/goals/${encodeURIComponent(props.goalId)}`, {withCredentials: true });
                  setGoal(response.data);
              } catch (error) {
                  console.log("subGoalRow: " + error);
              }
          }
      }
      // Fetch the detailed record for this goal.
      getGoal();
  }, [props, isLoggedIn]); 

  const handleReview = (id) => {
        navigate('/review-goal', { state: { id } });     
  };

  const handleSettings = (id) => {
        navigate('/edit-goal', { state: { id } });     
  };

  const handleUpdate = (id) => {
        navigate('/update-goal', { state: { id } });     
  };
       
return (
  <div className={'card-goal-type-' + goal.goal_type + ' black-border content-container d-flex align-items-center'}>
    <div className="left-content d-flex align-items-center flex-grow-1">
      <div className="RAG-status me-2">
        {goal.goal_type !== 7 ? (
          <RAGStatus color="b" status={goal.rag_status} />
        ) : (
          <BsFillStopwatchFill />
        )}
      </div>
      {goal.goal_type === 7 ? (
        <ProgressBarItem
          className="flex-grow-1"
          actualValue={goal.cd_days_to_go}
          totalValue={goal.cd_total_days}
          displayText={'T-' + goal.cd_days_to_go + ":" + goal.goal_title}
        />
      ) : (
        <div>{goal.goal_type === 6 ? ( goal.shortcode ? (goal.shortcode + ":" + goal.goal_title) : ( goal.goal_title)) : (goal.goal_title) }</div>
      )}
    </div>
    <div className="right-content d-flex align-items-center">
      <BsFillGearFill onClick={() => handleSettings(goal.id)} />
      <BsFillPencilFill
        className={'update-alert-' + (goal.alert === 1)}
        onClick={() => handleUpdate(goal.id)}
      />
      <BsBarChartLineFill onClick={() => handleReview(goal.id)} />
    </div>
  </div>
  );
}

export default SubGoalRow;
